import React from 'react';
import { Stack } from 'office-ui-fabric-react';
import { TodoListItem } from './TodoListItem';
export var TodoList = function (props) {
    var filter = props.filter, todos = props.todos, complete = props.complete, remove = props.remove, edit = props.edit;
    var filteredTodos = Object.keys(todos).filter(function (id) {
        return filter === 'all' || (filter === 'completed' && todos[id].completed) || (filter === 'active' && !todos[id].completed);
    });
    return (React.createElement(Stack, { gap: 10 }, filteredTodos.map(function (id) { return (React.createElement(TodoListItem, { key: id, id: id, todos: todos, complete: complete, remove: remove, edit: edit })); })));
};
